import * as React from 'react'

export const SvgAccountReturnsOutline = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 24 24" width={24} height={24} aria-hidden={true} {...props}>
    <path d="M17.618 4L20 8.764V21H4V8.764L6.382 4h11.236zm.381 6H6v9h12v-9zm-7.164 2v1.5H16v2h-5.166l.001 1.503L7.5 14.5l3.335-2.5zM11 6H7.618L6.616 8H11V6zm5.382 0H13v2h4.381l-.999-2z" />
  </svg>
)
export default SvgAccountReturnsOutline
